/**
 * Creates a new RadioactiveMaterialsWasteAlertsController.
 * @class
 */
import { SystemAlertsController } from '../../../system/alerts/system-alerts.component';

class RadioactiveMaterialsWasteAlertsController extends SystemAlertsController {
    /* @ngInject */
    constructor($ngRedux, $state, NavigationService) {
        super($ngRedux, $state, NavigationService);
        this.config = {
            filter: './rm-waste-alerts-grid-filter.html',
            columns: [
                {title: '#',                    mapper: null},
                {title: '',                     mapper: 'alert'},
                {title: 'Location',             mapper: 'location'},
                {title: 'Bin ID',               mapper: 'sourceId'},
                {title: 'Waste Type',           mapper: 'wasteType'},
                {title: 'Isotope',              mapper: 'isotope'},
                {title: 'Date of Closure',      mapper: 'dateOfClosure'},
                {title: 'Dose Rata at Date of Closure', mapper: 'doseRateAtClosure'},
                {title: 'Est. Date of Disposal', mapper: 'estDateOfDisposal'},
                {title: 'Disposal Dose Rate',   mapper: 'disposalDoseRate'}
            ]
        };
    }

    $onInit() {
        const navConfig = this.NavigationService.getConfig(this.$state.$current);
        this.colorName = navConfig.colorName;
        this.icon = navConfig.icon;
        this.rmWasteAlertsModuleID = 338;
    }

    onSelect(event) {
        // this.$state.go(this.state, {id: event.item.equipmentId});
    }
}

export const rmWasteAlerts = {
    bindings: {
        state: '@'
    },
    controller: RadioactiveMaterialsWasteAlertsController,
    template: `
        <system-alerts-grid identifier="rmWasteAlertsGrid"
                           module-id="$ctrl.rmWasteAlertsModuleID"
                           icon="alerts.svg"
                           config="$ctrl.config"
                           on-select="$ctrl.onSelect($event)">
        </system-alerts-grid>
    `
};
